<div class="container">
    <main class="row eui-u-flex-justify-content-center">
        <article class="col-md-8">
            <div class="eui-u-flex eui-u-flex-justify-content-center">
                <h1>{{ "page.feedback.title" | translate }}</h1>
            </div>
            <p>
                {{ "page.feedback.content" | translate }}<br />
                <a
                    [href]="'mailto:' + supportEmail"
                    [attr.aria-label]="'page.feedback.email' | translate"
                    role="link"
                >
                    {{ supportEmail() }}
                </a>
            </p>
        </article>
    </main>
</div>
